import { combineReducers } from 'redux';

import roundReducer from './reducers/roundReducer';

export const reducerCollection = {
  round: roundReducer,
};

const reducers = combineReducers({ ...reducerCollection });

export default reducers;
